import { BUGUN } from "../config.js";

export const money = n => n.toLocaleString("tr-TR") + " ₺";
export const AY_ADI = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
export const donemAdi = p => `${AY_ADI[Number(p.slice(5, 7)) - 1]} ${p.slice(0, 4)}`;
export function donemEkle(period, adim) {
  let y = Number(period.slice(0, 4)), a = Number(period.slice(5, 7)) - 1 + adim;
  y += Math.floor(a / 12); a = ((a % 12) + 12) % 12;
  return `${y}-${String(a + 1).padStart(2, "0")}`;
}

// Ücretler her eğitim yılında arttığı için geçmiş dönemler bugünkü
// tarifenin bir oranı olarak yazılır.
export function donemKatsayisi(period) {
  if (period >= "2025-09") return 1;
  if (period >= "2024-09") return 0.78;
  if (period >= "2023-09") return 0.60;
  return 0.45;
}
export const esc = s => String(s ?? "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function age(birthDate) {
  const b = new Date(birthDate), now = new Date();
  const months = (now.getFullYear() - b.getFullYear()) * 12 + (now.getMonth() - b.getMonth());
  const y = Math.floor(months / 12), m = months % 12;
  return y > 0 ? `${y} yaş${m ? ` ${m} ay` : ""}` : `${m} aylık`;
}

export function fmtDate(iso) {
  return new Date(iso + "T00:00:00").toLocaleDateString("tr-TR", { day: "numeric", month: "long" });
}
export const gunFarki = date => Math.round((new Date(BUGUN) - new Date(date.slice(0, 10))) / 86400000);
